import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      {/* Upper: Link Columns */}
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Column 1: Hot Categories */}
          <div>
            <h4 className="text-sm font-bold font-heading text-foreground-950 mb-4">
              <a href="/" className="hover:text-primary-500 transition-colors">热门分类</a>
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-sm font-bold font-heading text-foreground-950 mb-4">
              <a href="/" className="hover:text-primary-500 transition-colors">黑料频道</a>
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category/black-material" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">黑料爆料</Link></li>
              <li><Link to="/category/daily-must" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">每日必吃</Link></li>
              <li><Link to="/category/collection" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">吃瓜合集</Link></li>
              <li><Link to="/category/91-today" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">91今日吃瓜</Link></li>
            </ul>
          </div>

          {/* Column 3: Compliance */}
          <div>
            <h4 className="text-sm font-bold font-heading text-foreground-950 mb-4">
              <a href="/about" className="hover:text-primary-500 transition-colors">合规声明</a>
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">内容仅供参考</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">不构成事实认定</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">侵删请联系</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">理性吃瓜·文明上网</span></li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h4 className="text-sm font-bold font-heading text-foreground-950 mb-4">
              <a href="/about" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <ul className="flex flex-col gap-2.5">
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">邮箱：{siteInfo.contactEmail}</span></li>
              <li><span className="text-sm text-foreground-600 whitespace-nowrap">微信：{siteInfo.contactWechat}</span></li>
              <li><Link to="/about" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">关于品牌 →</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower: Brand + Copyright */}
      <div className="border-t border-background-200/70 px-4 md:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <h2 className="text-3xl md:text-4xl font-black font-heading text-foreground-950 leading-none">
              今日吃瓜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网黑料爆料聚合平台</p>
            <p className="text-xs text-foreground-400 mt-1">覆盖91今日吃瓜 · 51国产吃瓜在线 · 吃瓜合集</p>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-2">
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-accent-100 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-accent-100 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-accent-100 transition-colors cursor-pointer" rel="nofollow" aria-label="知乎">
                <i className="ri-question-answer-line text-foreground-600"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}